import { Link } from 'react-router-dom';
import { BarChart3, Map, AlertTriangle, Euro, ArrowRight, BookOpen } from 'lucide-react';
import { AnimatedSection, AnimatedItem, AnimatedCard } from '@/components/animations';
import { motion } from 'framer-motion';
import { staggerContainer } from '@/components/animations';

const assetLinks = [
  {
    to: '/mapa-normas-elevadores-portugal',
    icon: Map,
    title: 'Mapa de normas de elevadores',
    desc: 'EN 81, DL 320/2002 e Diretiva 2014/33/UE',
  },
  {
    to: '/vida-util-elevadores-estudo',
    icon: BarChart3,
    title: 'Estudo: vida útil dos elevadores',
    desc: 'Dados por componente e limiares de modernização',
  },
  {
    to: '/custo-elevadores-estudo-mercado',
    icon: Euro,
    title: 'Custos de elevadores: estudo de mercado',
    desc: 'Instalação, modernização e manutenção em Portugal',
  },
  {
    to: '/taxonomia-falhas-elevadores',
    icon: AlertTriangle,
    title: 'Taxonomia de falhas',
    desc: 'Classificação técnica de falhas mecânicas, elétricas e de segurança',
  },
];

export function AuthorityAssetsSection() {
  return (
    <section className="py-12 md:py-16 border-t border-border">
      <div className="container">
        <AnimatedSection className="max-w-5xl mx-auto" stagger>
          <AnimatedItem className="text-center mb-8">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-medium mb-4">
              <BookOpen className="w-3.5 h-3.5" />
              Recursos de Referência
            </div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground mb-2">
              Estudos e recursos técnicos
            </h2>
            <p className="text-muted-foreground text-sm max-w-xl mx-auto">
              Dados, mapas e análises técnicas de referência sobre elevadores em Portugal.
            </p>
          </AnimatedItem>

          <motion.div
            className="grid grid-cols-1 sm:grid-cols-2 gap-3"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-50px' }}
          >
            {assetLinks.map((link) => (
              <AnimatedItem key={link.to}>
                <Link to={link.to}>
                  <AnimatedCard className="p-4 rounded-xl bg-card border border-border hover:border-primary/40 transition-colors h-full">
                    <div className="flex items-start gap-3">
                      <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                        <link.icon className="w-4 h-4 text-primary" />
                      </div>
                      <div>
                        <h3 className="font-semibold text-foreground text-sm mb-0.5">{link.title}</h3>
                        <p className="text-xs text-muted-foreground">{link.desc}</p>
                      </div>
                    </div>
                  </AnimatedCard>
                </Link>
              </AnimatedItem>
            ))}
          </motion.div>

          <AnimatedItem className="text-center mt-6">
            <Link
              to="/recursos-tecnicos-elevadores"
              className="inline-flex items-center gap-1.5 text-sm text-primary font-medium hover:underline"
            >
              Ver todos os recursos técnicos
              <ArrowRight className="w-3.5 h-3.5" />
            </Link>
          </AnimatedItem>
        </AnimatedSection>
      </div>
    </section>
  );
}
